import { Component, Input, OnInit } from '@angular/core';
import { isWebview } from '@classifieds-sell/shared';

@Component({
    selector: 'tm-header',
    templateUrl: './tm-header.component.html',
    styleUrls: ['./tm-header.component.scss']
})
export class TmHeaderComponent implements OnInit {
    public isWebview: boolean;
    public member: any;

    @Input() tradeMeUrl: string;
    @Input() myTradeMeUrl: string;
    @Input() myPhotoUrl: string;

    ngOnInit(): void {
        this.isWebview = isWebview(window.location.search);
    }
}
